import { PreferenceApi, Preferences } from "@api";
import { Injector } from "../../injector";

const {
  preferenceApi,
} = Injector;

export class CommonService {
  constructor(private preferenceApi: PreferenceApi) {
  }

  public getPreferences = (): Promise<Preferences> => {
    return this.preferenceApi.getPreferences();
  }
}

export default new CommonService(preferenceApi);